import * as React from 'react';
import classnames from 'classnames';
import { st, classes } from './Card.st.css';
import { CardDataHooks, CardDataKeys, } from './types';
const Container = (props) => {
    const { className, children, minWidth } = props;
    return (React.createElement("div", { style: { flexBasis: minWidth }, className: classnames(classes.container, classes.overrideStyleParams, className), "data-hook": props['data-hook'] || CardDataHooks.CardContainer }, children));
};
/** An implementation of Card for TPAs */
export class Card extends React.Component {
    getDataAttributes() {
        const { stacked } = this.props;
        return {
            [CardDataKeys.Stacked]: stacked,
        };
    }
    render() {
        const { stacked, children, className } = this.props;
        return (React.createElement("section", { "data-hook": this.props['data-hook'], className: st(classes.root, { stacked }, className), ...this.getDataAttributes() }, children));
    }
}
Card.displayName = 'Card';
Card.defaultProps = {
    stacked: false,
};
Card.Container = Container;
//# sourceMappingURL=Card.js.map